import { QuotePlanSchema } from '../../../server/map-quotes';

export const filterInOtherArray = (
	filteredQuotes: QuotePlanSchema[],
	idArray: string[] | number[],
	searchId: keyof QuotePlanSchema
) => filteredQuotes.filter((obj) => idArray?.includes(obj[searchId as never]));
